/*
  Search as you type. Every search box on the site (header bar, phone menu,
  search page) gets a dropdown of matching products and menu sections
  while the shopper types. Results come from Shopify's built-in predictive
  search, rendered by sections/predictive-search.liquid. Enter with nothing
  highlighted still submits the normal search.
*/
(function () {
  var MIN = 2, DELAY = 220;
  var panel, current, timer, ctrl, cache = {};

  function makePanel() {
    panel = document.createElement('div');
    panel.className = 'ps-panel';
    panel.hidden = true;
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); }); // keep focus in the input
    document.body.appendChild(panel);
  }

  // Right under the search box, as wide as it (at least 300px), like the tag search.
  function place() {
    if (!current || panel.hidden) return;
    var box = current.closest('form') || current;
    var r = box.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var w = Math.min(Math.max(r.width, 300), vw - 16);
    var left = r.left;
    if (left + w > vw - 8) left = r.right - w; // near the right edge: line up the right sides
    left = Math.max(8, Math.min(left, vw - w - 8));
    panel.style.top = (r.bottom + 2) + 'px';
    panel.style.left = left + 'px';
    panel.style.width = w + 'px';
  }

  function close() {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    if (current) current.setAttribute('aria-expanded', 'false');
  }

  /* ---------- Menu sections ----------
     Sections from the site menu (Bowls, Drinkware, Salt + pepper...) that
     match what's typed show at the top. "and", "&", "," and "+" all count as
     the same, so "salt and pepper" finds "Salt + pepper". */
  var menu;
  function norm(s) {
    return (s || '').toLowerCase().replace(/&|\+|,|\band\b/g, ' ').replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();
  }
  function menuIndex() {
    if (menu) return menu;
    menu = [];
    var seen = {};
    (function walk(items, trail) {
      items.forEach(function (it) {
        if (it.url && it.url !== '#' && !seen[it.url]) {
          seen[it.url] = 1;
          menu.push({ title: it.title, url: it.url, trail: trail.join(' \u203a '), words: norm(it.title).split(' ') });
        }
        walk(it.children || [], trail.concat(it.title));
      });
    })(window.ahhMenu ? window.ahhMenu.tree() : [], []);
    return menu;
  }
  function menuHits(q) {
    var qw = norm(q).split(' ').filter(Boolean);
    if (!qw.length) return [];
    var whole = qw.join(' ');
    return menuIndex().filter(function (m) {
      return qw.every(function (w) { return m.words.some(function (t) { return t.indexOf(w) === 0; }); });
    }).sort(function (a, b) {
      var ra = a.words.join(' ') === whole ? 0 : 1, rb = b.words.join(' ') === whole ? 0 : 1;
      return ra - rb || a.words.length - b.words.length;
    }).slice(0, 4);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function withMenu(html, q) {
    var hits = menuHits(q);
    if (!hits.length) return html;
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var res = wrap.firstElementChild;
    if (!res) return html;
    // Same page already listed under Collections: keep it there only once.
    var path = function (u) { try { return new URL(u, location.href).pathname.replace(/\/$/, ''); } catch (e) { return u; } };
    var listed = {};
    Array.prototype.forEach.call(res.querySelectorAll('.ps__list--links a'), function (a) { listed[path(a.getAttribute('href'))] = a; });
    var out = '';
    hits.forEach(function (h) {
      var dup = listed[path(h.url)];
      if (dup) dup.parentNode.parentNode.removeChild(dup.parentNode);
      out += '<li class="ps__item" role="option"><a class="ps__link" href="' + esc(h.url) + '" tabindex="-1"><span class="ps__text"><span class="ps__title">' +
        esc(h.title) + '</span>' + (h.trail ? '<span class="ps__price">' + esc(h.trail) + '</span>' : '') + '</span></a></li>';
    });
    var links = res.querySelector('.ps__list--links');
    if (links && !links.children.length) { links.previousElementSibling.remove(); links.remove(); }
    var empty = res.querySelector('.ps__empty');
    if (empty) empty.remove();
    res.insertAdjacentHTML('afterbegin', '<p class="ps__label">In the menu</p><ul class="ps__list ps__list--menu" role="listbox">' + out + '</ul>');
    return res.outerHTML;
  }

  function show(html) {
    if (current) html = withMenu(html, current.value.trim());
    panel.innerHTML = html;
    panel.hidden = false;
    current.setAttribute('aria-expanded', 'true');
    place();
  }

  function links() { return panel.querySelectorAll('.ps__link'); }

  function move(step) {
    var all = links(); if (!all.length) return;
    var i = Array.prototype.indexOf.call(all, panel.querySelector('.ps__link.is-active'));
    if (i > -1) all[i].classList.remove('is-active');
    i = i + step;
    if (i < 0) i = all.length - 1;
    if (i >= all.length) i = 0;
    all[i].classList.add('is-active');
    all[i].scrollIntoView({ block: 'nearest' });
  }

  function search(q) {
    if (cache[q]) return show(cache[q]);
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    // "salt and pepper" / "salt & pepper" search the same as "salt pepper".
    var terms = q.replace(/\s*(&|\+|,|\band\b)\s*/gi, ' ').trim() || q;
    var url = '/search/suggest?q=' + encodeURIComponent(terms) +
      '&resources[type]=product&resources[limit]=6' +
      '&resources[options][unavailable_products]=last&section_id=predictive-search';
    fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var res = doc.querySelector('#PredictiveSearchResults');
        if (!res) return;
        cache[q] = res.outerHTML;
        if (current && current.value.trim() === q) show(cache[q]);
      })
      .catch(function () {});
  }

  function onInput(e) {
    current = e.target;
    var q = current.value.trim();
    clearTimeout(timer);
    if (q.length < MIN) return close();
    timer = setTimeout(function () { search(q); }, DELAY);
  }

  function onKey(e) {
    if (panel.hidden) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
    else if (e.key === 'Escape') { current.value = ''; close(); }
    else if (e.key === 'Enter') {
      var a = panel.querySelector('.ps__link.is-active');
      if (a) { e.preventDefault(); window.location.href = a.href; }
    }
  }

  function bind(input) {
    if (input.dataset.psBound) return;
    input.dataset.psBound = '1';
    if (!panel) makePanel();
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-haspopup', 'listbox');
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onKey);
    input.addEventListener('focus', function () {
      current = input;
      var q = input.value.trim();
      if (q.length >= MIN && cache[q]) show(cache[q]);
    });
    input.addEventListener('blur', function () { setTimeout(close, 150); });
  }
  // Search boxes added later (e.g. the phone menu's) call this.
  window.ahhPredictiveSearch = { bind: bind };

  function init() {
    var inputs = document.querySelectorAll('form[action*="/search"] input[name="q"]');
    Array.prototype.forEach.call(inputs, bind);
    window.addEventListener('resize', place);
    window.addEventListener('scroll', place, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
